"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-four/sections/blogSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BlogSectionBlogFourFadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "0.2s" | "0.3s" | "0.4s" */
    dataWowDelay: string;
    /** Detected variants: "Newborn" | "Immunization" | "Nutrition" */
    link0Text: ReactNode;
    /** Detected variants: "29, Nov 2026" | "30, Nov 2026" */
    p0Text: ReactNode;
    /** Detected variants: "Essential Newborn Care Tips for First-Time Parents" | "Why Vaccinations Are Vital for Your Child’s Health" | "Dealing with Picky Eaters: Practical Tips for Parents" */
    link0Link0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/blog/blog-11.jpg" | "/Templates/Doccure/img/blog/blog-12.jpg" | "/Templates/Doccure/img/blog/blog-13.jpg" */
    src: string;
    /** Detected variants: "blog-item-four wow fadeInUp" */
    className?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "blog-content" */
    div0ClassName?: string;
    /** Detected variants: "blog-info" */
    div0ClassName2?: string;
    /** Detected variants: "badge" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "date" */
    p0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.blogDetails" */
    link0Href?: string;
    /** Detected variants: "blog-img" */
    div1ClassName?: string;
    /** Detected variants: "all_routes.blogDetails" */
    link0Href2?: string;
    /** Detected variants: "blog" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
};
export type HomeFourBlogSectionGeneratedProps = {
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSectionBlogFourFadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSectionBlogFourFadeInUpsItem) => Partial<ComponentProps<"h3">>);
    divDiv0H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSectionBlogFourFadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSectionBlogFourFadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv1Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSectionBlogFourFadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "0.2s" */
    sectionDiv0Div0Div0Div0DivDataWowDelay?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "Our Solutions" */
    sectionDiv0Div0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "Latest Blogs & Articles from" */
    sectionDiv0Div0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Doccure" */
    sectionDiv0Div0Div0Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "all_routes.blogGrid" */
    sectionDiv0Div0Div0Div0Link0LinkHref?: string;
    /** Default: "View More" */
    sectionDiv0Div0Div0Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Div0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Comprehensive services prioritize the health, development, and well-being of your child at every stage of growth." */
    sectionDiv0Div0Div0Div0P0PText?: ReactNode;
    blogSectionBlogFourFadeInUps: BlogSectionBlogFourFadeInUpsItem[];
    blogSectionBlogFourFadeInUpsItemWrapper?: (item: BlogSectionBlogFourFadeInUpsItem, content: ReactNode) => ReactNode;
    blogSectionBlogFourFadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    blogSectionBlogFourFadeInUpsLinkVisible?: boolean;
    blogSectionBlogFourFadeInUpsLinkRenderer?: (item: BlogSectionBlogFourFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    blogSectionBlogFourFadeInUpsImageVisible?: boolean;
    blogSectionBlogFourFadeInUpsImageRenderer?: (item: BlogSectionBlogFourFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    blogSectionBlogFourFadeInUpsH3Visible?: boolean;
    blogSectionBlogFourFadeInUpsH3Renderer?: (item: BlogSectionBlogFourFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    blogSectionBlogFourFadeInUpsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSectionBlogFourFadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    blogSectionBlogFourFadeInUpsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSectionBlogFourFadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    blogSectionBlogFourFadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSectionBlogFourFadeInUpsItem) => Partial<ComponentProps<"h3">>);
};

const HomeFourBlogSectionGenerated: FC<HomeFourBlogSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0Div0DivText = "Our Solutions",
    sectionDiv0Div0Div0Div0Div0H20H2Text = "Latest Blogs & Articles from",
    sectionDiv0Div0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0Div0H20Span0SpanText = "Doccure",
    sectionDiv0Div0Div0Div0DivDataWowDelay = "0.2s",
    sectionDiv0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0Link0LinkHref = "all_routes.blogGrid",
    sectionDiv0Div0Div0Div0Link0LinkText = "View More",
    sectionDiv0Div0Div0Div0Link0LinkVisible,
    sectionDiv0Div0Div0Div0Link0LinkRenderer,
    sectionDiv0Div0Div0Div0Link0LinkProps,
    sectionDiv0Div0Div0Div0P0PText = "Comprehensive services prioritize the health, development, and well-being of your child at every stage of growth.",
    divDiv0Div0Link0LinkProps,
    divDiv0H30H3Props,
    divDiv0H30Link0LinkProps,
    divDiv1Link0ImageWithBasePath0ImageProps,
    divDiv1Link0LinkProps,
    sectionDiv0Div0ClassName,
    blogSectionBlogFourFadeInUps,
    blogSectionBlogFourFadeInUpsItemWrapper,
    blogSectionBlogFourFadeInUpsRenderer,
    blogSectionBlogFourFadeInUpsLinkVisible,
    blogSectionBlogFourFadeInUpsLinkRenderer,
    blogSectionBlogFourFadeInUpsImageVisible,
    blogSectionBlogFourFadeInUpsImageRenderer,
    blogSectionBlogFourFadeInUpsH3Visible,
    blogSectionBlogFourFadeInUpsH3Renderer,
    blogSectionBlogFourFadeInUpsLinkProps,
    blogSectionBlogFourFadeInUpsImageProps,
    blogSectionBlogFourFadeInUpsH3Props,
}) => {
    return (
        <section className="blog-section-four section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row g-4"}>
                    <div className="col-lg-5">
                        <div className="blog-header wow fadeInUp" data-wow-delay={sectionDiv0Div0Div0Div0DivDataWowDelay} data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                            <div className="section-header section-header-four">
                                <div className="section-sub-title">{sectionDiv0Div0Div0Div0Div0Div0DivText}</div>
                                {renderNode(sectionDiv0Div0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0Div0H20H2Renderer, (
                                    <h2 className="section-title" {...(sectionDiv0Div0Div0Div0Div0H20H2Props ?? {})}>
                                        {sectionDiv0Div0Div0Div0Div0H20H2Text}
                                        <span>{sectionDiv0Div0Div0Div0Div0H20Span0SpanText}</span>
                                    </h2>
                                ))}
                            </div>
                            <p>{sectionDiv0Div0Div0Div0P0PText}</p>
                            {renderNode(sectionDiv0Div0Div0Div0Link0LinkVisible, sectionDiv0Div0Div0Div0Link0LinkRenderer, (
                                <SmartLink href={sectionDiv0Div0Div0Div0Link0LinkHref} className="btn btn-light" {...(sectionDiv0Div0Div0Div0Link0LinkProps ?? {})}>
                                    {sectionDiv0Div0Div0Div0Link0LinkText}
                                    <i className="isax isax-arrow-right-1 ms-2" />
                                </SmartLink>
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-7">
                        {renderCollectionNode(
                            blogSectionBlogFourFadeInUps,
                            (item: BlogSectionBlogFourFadeInUpsItem) => (
                                <div className={item.className ?? "blog-item-four wow fadeInUp"} data-wow-delay={item.dataWowDelay} data-wow-duration={item.dataWowDuration ?? "1s"} key={item.key}>
                                    <div className={item.div0ClassName ?? "blog-content"}>
                                        <div className={item.div0ClassName2 ?? "blog-info"}>
                                            {renderItemNode(blogSectionBlogFourFadeInUpsLinkVisible, blogSectionBlogFourFadeInUpsLinkRenderer, item, (
                                                <SmartLink href={item.href ?? "#"} className={item.link0ClassName ?? "badge"} {...(typeof blogSectionBlogFourFadeInUpsLinkProps === "function" ? blogSectionBlogFourFadeInUpsLinkProps(item) : (blogSectionBlogFourFadeInUpsLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                            ))}
                                            <p className={item.p0ClassName ?? "date"}>{item.p0Text}</p>
                                        </div>
                                        {renderItemNode(blogSectionBlogFourFadeInUpsH3Visible, blogSectionBlogFourFadeInUpsH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof blogSectionBlogFourFadeInUpsH3Props === "function" ? blogSectionBlogFourFadeInUpsH3Props(item) : (blogSectionBlogFourFadeInUpsH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>
                                                {renderItemNode(blogSectionBlogFourFadeInUpsLinkVisible, blogSectionBlogFourFadeInUpsLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href ?? "all_routes.blogDetails"} {...(typeof blogSectionBlogFourFadeInUpsLinkProps === "function" ? blogSectionBlogFourFadeInUpsLinkProps(item) : (blogSectionBlogFourFadeInUpsLinkProps ?? {}))} {...(typeof divDiv0H30Link0LinkProps === "function" ? divDiv0H30Link0LinkProps(item) : (divDiv0H30Link0LinkProps ?? {}))}>{item.link0Link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "blog-img"}>
                                        {renderItemNode(blogSectionBlogFourFadeInUpsLinkVisible, blogSectionBlogFourFadeInUpsLinkRenderer, item, (
                                            <SmartLink href={item.link0Href2 ?? "all_routes.blogDetails"} {...(typeof blogSectionBlogFourFadeInUpsLinkProps === "function" ? blogSectionBlogFourFadeInUpsLinkProps(item) : (blogSectionBlogFourFadeInUpsLinkProps ?? {}))} {...(typeof divDiv1Link0LinkProps === "function" ? divDiv1Link0LinkProps(item) : (divDiv1Link0LinkProps ?? {}))}>
                                                {renderItemNode(blogSectionBlogFourFadeInUpsImageVisible, blogSectionBlogFourFadeInUpsImageRenderer, item, (
                                                    <SmartImage className={item.imageWithBasePath0ClassName ?? "img-fluid"} src={item.src} alt={item.alt ?? "blog"} {...(typeof blogSectionBlogFourFadeInUpsImageProps === "function" ? blogSectionBlogFourFadeInUpsImageProps(item) : (blogSectionBlogFourFadeInUpsImageProps ?? {}))} {...(typeof divDiv1Link0ImageWithBasePath0ImageProps === "function" ? divDiv1Link0ImageWithBasePath0ImageProps(item) : (divDiv1Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                    </div>
                                </div>
                            ),
                            blogSectionBlogFourFadeInUpsItemWrapper,
                            blogSectionBlogFourFadeInUpsRenderer
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeFourBlogSectionGenerated;
